export default "__VITE_ASSET__22c3200f__"